module.exports = __webpack_public_path__ + "static/img/3.55eadb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quartos/suite2/3.jpg
// module id = I83T
// module chunks = 1